import { inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { B04UserFacade } from '../facade/b04-user.facade';
import { B04UserStore } from '../store/b04-user.store';

export function provideB04User() {
  return makeEnvironmentProviders([
    B04UserStore,
    B04UserFacade,
    // Signal stores are created lazily on first injection — but nothing injects this store
    // before login completes, and its sync handler must already be listening to the auth
    // state from app init, so it is instantiated eagerly here.
    provideEnvironmentInitializer(() => inject(B04UserStore)),
  ]);
}
